export const baseData = {
  title: "PAYMENT TERM CUSTOMER"
}